import React, {PropTypes} from 'react'
import Moment from 'moment'
import {Card, CardHeader, CardText} from 'material-ui/Card'
import {blue500} from 'material-ui/styles/colors'
import './Supply.css'

import Done from 'material-ui/svg-icons/action/done'
import Autorenew from 'material-ui/svg-icons/action/autorenew'

const FREQUENCY_INVERTER_ACTIVATION_ROLE = 17
const REQUEST_BUILDING_ROLE = 31

const getDescription = (state, created_at, isRequest = false) => {
  if (created_at === undefined) {
    if (state === undefined) {
      return 'Sem informação'
    }
    return state ? (isRequest ? 'Solicitando' : 'Abastecendo') : 'Abastecido'
  }
  const description = state ? (isRequest ? 'Solicitando desde' : 'Abastecendo desde') : 'Abastecido desde'
  const date = Moment(created_at).format('DD/MM [às] h:mm')
  return `${description} ${date}`
}

const IconSupply = (props) => {
  const {mode, style, ...rest} = props
  if (mode) {
    return <Autorenew {...rest} style={{...style, animation:  'supplySpin 5s infinite linear'}} color={blue500}/>
  }
  return <Done {...rest} style={style} color={blue500}/>
}

const Supply = ({informations, style}) => {
  const { informationRequest, informationSupply } = informations.reduce((obj, curr) => {
    if (curr.role === REQUEST_BUILDING_ROLE) {
      obj.informationRequest = curr
    }
    if (curr.role === FREQUENCY_INVERTER_ACTIVATION_ROLE) {
      obj.informationSupply = curr
    }
    return obj
  }, {})

  let lastUpdate = {}
  let isRequest = false

  if (informationSupply !== undefined) {
    lastUpdate = informationSupply.updates.length > 0 ? informationSupply.updates[0] : {}
  } else if (informationRequest !== undefined) {
    lastUpdate = informationRequest.updates.length > 0 ? informationRequest.updates[0] : {}
    isRequest = true
  }

  const { data, created_at } = lastUpdate

  return (
    <Card style={{
      ...style
    }}>
      <CardHeader
        title={isRequest ? 'Solicitação' : 'Abastecimento'}
        subtitle={getDescription(data === 1, created_at, isRequest)}
        textStyle={{ padding: 0 }}
        style={{ paddingBottom: 0 }}
      />
      <CardText>
        <IconSupply style={{
          height: 'inherit',
          width: '80%',
          marginLeft: '10%'
        }} mode={data === 1} />
      </CardText>
    </Card>
  )
}

Supply.propTypes = {
  informations: PropTypes.array.isRequired
}

export default Supply



/** WEBPACK FOOTER **
 ** ./src/components/dashboard/Supply.js
 **/